var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 273,
    y: 556,
    width: 29,
    height: 29
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5)",
    transform: "translate(-273 -556)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M281.76 563.854C282.274 563.854 282.667 563.461 282.667 562.948L282.667 561.135C282.667 560.622 282.274 560.229 281.76 560.229 281.247 560.229 280.854 560.622 280.854 561.135L280.854 562.948C280.854 563.461 281.247 563.854 281.76 563.854Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.042 576.542 283.875 576.542 283.875 578.958 279.042 578.958 279.042 576.542ZM279.042 572.917 283.875 572.917 283.875 575.333 279.042 575.333 279.042 572.917ZM279.042 569.292 283.875 569.292 283.875 571.708 279.042 571.708 279.042 569.292ZM289.917 569.292 289.917 571.708 285.083 571.708 285.083 569.292 289.917 569.292ZM295.958 569.292 295.958 571.708 291.125 571.708 291.125 569.292 295.958 569.292ZM295.958 575.333 291.125 575.333 291.125 572.917 295.958 572.917 295.958 575.333ZM295.958 578.958 291.125 578.958 291.125 576.542 295.958 576.542 295.958 578.958ZM285.083 575.333 285.083 572.917 289.917 572.917 289.917 575.333 285.083 575.333ZM285.083 578.958 285.083 576.542 289.917 576.542 289.917 578.958 285.083 578.958ZM277.229 580.771 297.771 580.771 297.771 567.479 277.229 567.479 277.229 580.771Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.24 563.854C293.753 563.854 294.146 563.461 294.146 562.948L294.146 561.135C294.146 560.622 293.753 560.229 293.24 560.229 292.726 560.229 292.333 560.622 292.333 561.135L292.333 562.948C292.333 563.461 292.726 563.854 293.24 563.854Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.354 562.042 295.354 562.948C295.354 564.126 294.418 565.062 293.24 565.062 292.061 565.062 291.125 564.126 291.125 562.948L291.125 562.042 283.875 562.042 283.875 562.948C283.875 564.126 282.939 565.062 281.76 565.062 280.582 565.062 279.646 564.126 279.646 562.948L279.646 562.042 277.229 562.042 277.229 566.271 297.771 566.271 297.771 562.042 295.354 562.042Z",
    fill: "current"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavCalendar);
export default __webpack_public_path__ + "static/media/nav-calendar.b6670d6a0e3549df6bba0beb0353a60e.svg";
export { ForwardRef as ReactComponent };